module.exports = __webpack_public_path__ + "img/filledBookmark.18c3040d.svg";